export enum Package {
  START = 'START',
  PLUS = 'PLUS',
  PREMIUM = 'PREMIUM',
}
